module.exports = __webpack_public_path__ + "img/pie-chart-bg.2eecf4bf.svg";